import { emptySplitApi } from "./empty-split-api";
import {
  ManufacturersFilter,
  ManufacturersResponse
} from "./types/manufacturers.type";

const extendedManufacturersApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getManufacturers: builder.query<ManufacturersResponse, ManufacturersFilter>(
      {
        query: ({ search, practice_filtered }) => {
          let url = `manufacturers/?limit=300&search=${encodeURIComponent(search)}`;
          if (practice_filtered) {
            url += `&practice_filtered=true`;
          }
          return url;
        },
        providesTags: ["Manufacturers"]
      }
    )
  })
});

export const { useGetManufacturersQuery } = extendedManufacturersApi;
